var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"big-title"},[_c('span'),_c('h2',{staticClass:"big-title-text"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }